import { useQuery } from "@tanstack/react-query"
import { useAuth } from "~Shared/hooks/auth.hooks"
import { CacheEnum } from "~Shared/queries/consts"
import { CompanyService } from "~Shared/services/company.service"

/** For callers rendered outside the subtree `DataFetcher` fills; anything inside `Main` should use `useCompany`, which costs no request. */
export const useActiveCompanyQuery = () => {
    const { companyId } = useAuth()

    return useQuery({
        queryKey: [CacheEnum.COMPANIES],
        queryFn: () => CompanyService.fetchCompanies(),
        select: (companies) => companies.find(({ _id }) => _id === companyId),
        enabled: !!companyId,
    })
}
